import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { browserName } from "react-device-detect";
import CaptchaTest from "../Components copy/Captcha/CaptchaTest";
import {
  sendMobileNoAPICall,
  locationCheckAPICall,
  AdminLoginToClientAccountAPICall,
} from "../shared copy/APICalls";
import { IAdminLogin, IMobile } from "../shared copy/dtos";
import routesData from "../shared copy/routes.json";
import SignupStyles from "../pages copy/Styles/Mobile.module.scss";
import SignUpImage from "../Components copy/assets/Images/newLeftImage.svg";
import SnackBar from "../Components copy/SnackBars/SnackBar";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";
import mobileviewimage from "../Components copy/assets/Images/mobileviewgiftbox.svg";
import video from "../Components copy/assets/Images/mobilescreenvideo.mov";

export default function MobilePage() {
  const navigate = useNavigate();
  const pathName = useLocation().pathname;
  const [userDeniedLocation, setuserDeniedLocation] = useState(false);
  const [active, setactive] = useState(false);
  const [isSafari, setisSafari] = useState(false);
  const [intervalId, setintervalId] = useState<any>(null);
  const [isFireFox, setisFireFox] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchSubmit, setcaptchSubmit] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setloading] = useState(false);
  const [showContent, setshowContent] = useState(true);
  const [message, setMessage] = useState("");
  const [latitudeAccess, setLocationAccess] = useState<any>();

  const navigationData: any = routesData;

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);

  if (source) {
    sessionStorage.setItem("source", source);
    sessionStorage.setItem("id", id);
  }

  function sendMobileNumber(data: any) {
    setloading(true);
    let obj: IMobile = {
      mobile: data,
    };
    sendMobileNoAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setloading(false);
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage], {
            state: { mobile: data },
          });
        }
      })
      .catch((error: any) => {
        setloading(false);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.error.message
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
        // setMessage(error.response.data.error.message);
        // setTimeout(() => {
        //   setMessage("");
        // }, 5000);
      });
  }

  useEffect(() => {
    // Admin Login

    getLocation();

    return () => clearInterval(intervalId);
  }, [pathName]);

  useEffect(() => {
    if (
      userDeniedLocation &&
      intervalId === null &&
      browserName !== "Firefox"
    ) {
      let interval = setInterval(() => {
        getLocation();
      }, 1000);
      setintervalId(interval);
    }
  }, [userDeniedLocation]);

  // useEffect(() => {
  //   if (captcha === "Captcha Matched") {
  //     //sendMobileNumber();
  //   } else {
  //     setcaptchSubmit(false);
  //   }
  // }, [captcha]);

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      // console.log("Geolocation is not supported by this browser.");
    }
  }

  function showPosition(position: any) {
    setuserDeniedLocation(false);
    // console.log(
    //   "Position",
    //   "Latitude: " +
    //     position.coords.latitude +
    //     "Longitude: " +
    //     position.coords.longitude
    // );
    const latitudeCoords = position.coords.latitude;
    const longitudeCoords = position.coords.longitude;
    setLocationAccess(latitudeCoords);

    sessionStorage.setItem("latitude", latitudeCoords);
    sessionStorage.setItem("longitude", longitudeCoords);

    locationCheckAPICall(position.coords.latitude, position.coords.longitude)
      .then((response: any) => {
        const responseData = response.data;
        // console.log(responseData.status,"responseData")
        //  if(responseData.status=== true){
        //   setshowContent(true)
        //  }
      })
      .catch((error: any) => {
        // setshowContent(false)
      });

    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  function showError(error: any) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        // console.log("User denied the request for Geolocation.");
        setuserDeniedLocation(true);
        if (browserName === "Firefox") {
          setisFireFox(true);
        }

        break;

      case error.POSITION_UNAVAILABLE:
        // console.log("Location information is unavailable.");

        break;
      case error.TIMEOUT:
        // console.log("The request to get user location timed out.");

        break;
      case error.UNKNOWN_ERROR:
        // console.log("An unknown error occurred.");

        break;
    }
  }

  function validatePhoneNumber(value: any) {
    let error: any;
    if (!value) {
      error = "Mobile Number Required";
    } else if (!/^[0-9]{10}$/.test(value)) {
      error = "Must be a valid 10 digit mobile number";
    }
    return error;
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const listener = (event: any) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Enter key was pressed. Run your function.");
        const onFormSubmit = (values: any) => {
          setcaptchSubmit(true);
          setMobileNumber(values.phoneNumber);
          sendMobileNumber(values.phoneNumber);
        };

        event.preventDefault();
        // callMyFunction();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <>
      <div className={SignupStyles.mobileHeader}>
        <p className={SignupStyles.LeftContainerHeadermobileHeader}>
          Welcome to Firstock Partners
        </p>
        <p className={SignupStyles.LeftContainerSubTextmobileHeader}>
          Just a couple of clicks and we start.
        </p>
      </div>
      <div className={SignupStyles.wrapper}>
        <div className={SignupStyles.LeftContainer}>
          <p className={SignupStyles.LeftContainerHeader}>
            Welcome to Firstock Partners
          </p>
          <p className={SignupStyles.LeftContainerSubText}>
            Just a couple of clicks and we start.
          </p>
          {/* <video autoPlay={true} loop muted className={SignupStyles.video}>
            <source
              src={video}
              type="video/mp4"
            />
          </video> */}
          <img src={SignUpImage} alt="Image" className={SignupStyles.image} />
        </div>
        <div className={SignupStyles.RightContainer}>
          <div className={SignupStyles.headerSection}>
            <p className={SignupStyles.signup}>
              Signup now by Entering Your Contact Details
            </p>
            <p className={SignupStyles.subText}>
              Join a community of partners earning with Firstock.
            </p>
          </div>

          <div>
            {showContent ? (
              <Formik
                initialValues={{
                  phoneNumber: "",
                }}
                onSubmit={(values) => {
                  // console.log(values);
                  setcaptchSubmit(true);
                  setMobileNumber(values.phoneNumber);
                  sendMobileNumber(values.phoneNumber);
                  // if (captcha === "Captcha Matched") {
                  //   navigate("/confirm_otp");
                  // }
                }}
              >
                {({ errors, touched, handleChange, values, handleSubmit }) => (
                  <Form
                    onKeyDown={(event) => {
                      event.code === "Enter" && handleSubmit();

                      // event.code.includes("Enter") && handleSubmit()
                    }}
                  >
                    {!userDeniedLocation ? (
                      <>
                        <div className="">
                          <Field
                            name="phoneNumber"
                            validate={validatePhoneNumber}
                            render={({ field }: any) => (
                              <TextField
                                {...field}
                                label=""
                                type="numeric"
                                sx={{
                                  fieldset: { borderColor: "#007585" },
                                }}
                                placeholder="Enter Mobile Number"
                                className={SignupStyles.textfield}
                                // style={{ width: "300px", margin: "10px 0px" }}
                                variant="outlined"
                                value={values.phoneNumber}
                                helperText={
                                  errors.phoneNumber &&
                                  touched.phoneNumber && (
                                    <FormHelperText
                                      style={{ color: "#d32f2f" }}
                                    >
                                      {errors.phoneNumber}
                                    </FormHelperText>
                                  )
                                }
                                onChange={handleChange}
                                inputProps={{
                                  sx: {
                                    "&::placeholder": {
                                      paddingLeft: "10px",
                                    },
                                    borderLeft: "1px solid #007585",
                                    paddingLeft: "10px",
                                  },
                                  maxLength: 10,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      +91
                                    </InputAdornment>
                                  ),
                                }}
                                onKeyPress={(event) => {
                                  const keyCode = event.keyCode || event.which;
                                  const keyValue = String.fromCharCode(keyCode);
                                  const isValidKey = /^\d+$/.test(keyValue);

                                  if (!isValidKey) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            )}
                          />
                          <p className={SignupStyles.smallText}>
                            You will receive an OTP on your number
                          </p>

                          <SnackBar message={message} />
                          <div className={SignupStyles.mobileImage}>
                            <img
                              src={mobileviewimage}
                              alt="Image"
                              className={SignupStyles.imageMobileView}
                            />
                          </div>
                          <div className={SignupStyles.buttonSection}>
                            {values.phoneNumber.length === 10 ? (
                              <LoadingButton
                                variant="contained"
                                type="submit"
                                loading={loading}
                                id="signupContinueButton"
                                className={SignupStyles.button}
                                onClick={() => {
                                  handleSubmit();
                                }}
                              >
                                Continue
                              </LoadingButton>
                            ) : (
                              <Button
                                variant="contained"
                                disabled
                                className={SignupStyles.button}
                              >
                                Continue
                              </Button>
                            )}
                          </div>
                          <div className={SignupStyles.resendSection}>
                            <p className={SignupStyles.clickhere}>
                              Already have an account?
                            </p>
                            <a
                              target="_blank"
                              style={{ textDecoration: "underline" }}
                              className={SignupStyles.change}
                              onClick={() => {
                                navigate("/login");
                              }}
                            >
                              Login
                            </a>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          // alignItems={"center"}
                          // justifyContent={"center"}
                          // marginTop={"200px"}
                          className={SignupStyles.blockedtext}
                        >
                          <p>
                            Location Access is blocked, please grant the
                            Loaction access in browser settings to proceed
                            further{" "}
                          </p>
                        </div>
                        {isFireFox && (
                          <div
                          // alignItems={"center"}
                          // justifyContent={"center"}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => {
                                window.location.reload();
                              }}
                              id="signupReloadButton"
                            >
                              Reload
                            </Button>
                          </div>
                        )}
                        {isSafari ? (
                          <div
                          // alignItems={"center"}
                          // justifyContent={"center"}
                          >
                            <Typography>
                              Please Press Reload Button after granting camera
                              access
                            </Typography>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                window.location.reload();
                              }}
                              id="signupSafariReloadButton"
                            >
                              Reload
                            </Button>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Form>
                )}
              </Formik>
            ) : (
              <div
              // marginTop={'150px'}
              >
                Access Allowed Only in India{" "}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
